import { capitalize } from '@/helpers/string-helpers'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { GridTab } from '@/scopes/prices/components/GridTabs'
import { useGridTabsContext } from '@/scopes/prices/components/GridTabsContext'
import { PricesUseCasesContext } from '@/scopes/prices/components/PricesUseCasesContext'
import { monthFilterOptionsSelector } from '@/scopes/prices/components/selectors'
import { createPricesFilterClickEvent } from '@/scopes/prices/domain/analytics'
import { FiltersInPricesValues } from '@/scopes/prices/domain/filters/types'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'

export function MonthFilter() {
  const { sendEvent } = useAnalytics()
  const { selectFilter } = React.useContext(PricesUseCasesContext)
  const { options, selectedValue } = usePricesSelector(monthFilterOptionsSelector)
  const { selectedTab, setSelectedTab } = useGridTabsContext()

  const setSelection = (selection: FiltersInPricesValues) => selectFilter({ type: 'Month', selection })

  React.useEffect(() => {
    setSelectedTab(selectedValue)
  }, [selectedValue])

  const handleOnClick = (value: string) => {
    setSelection(value)
    setSelectedTab(value)
    sendEvent(
      createPricesFilterClickEvent({
        element: 'tab',
        type: 'month',
        result: value,
      }),
    )
  }

  return (
    <>
      {options.map(({ name, value }) => (
        <GridTab key={value} onClick={() => handleOnClick(value)} $selected={selectedTab === value}>
          <Typography $variant="label">{capitalize(name)}</Typography>
        </GridTab>
      ))}
    </>
  )
}
